import { Injectable } from '@angular/core';
import { WebSocketService } from './websocket/WebSocketService';

@Injectable({
  providedIn: 'root'
})
export class UserStatusLoggerService {
  private static connectionLogShown = false;
  private initialized = false;

  constructor(
    private webSocketService: WebSocketService
  ) {}

  /**
   * Inicializa el servicio de logs de estado de usuarios
   */
  initialize(): void {
    if (this.initialized) {
      return;
    }

    // Suscribirse a los eventos de conexión/desconexión del WebSocket
    this.webSocketService.getConnectionStatus().subscribe(connected => {
      if (connected) {
        // Reducir logs - solo mostrar una vez por sesión
        if (!UserStatusLoggerService.connectionLogShown) {
          UserStatusLoggerService.connectionLogShown = true;
        }
      } else {
        UserStatusLoggerService.connectionLogShown = false;
      }
    });
    this.initialized = true;
  }

  /**
   * Resetea los flags de logs
   */
  resetLogs(): void {
    UserStatusLoggerService.connectionLogShown = false;
  }
}
